// extracted by mini-css-extract-plugin
export default {"view-layout":"view-layout--TJlNx","viewLayout":"view-layout--TJlNx","left":"left--WCrDo","right":"right--LUNsk"};